module.exports = __webpack_public_path__ + "static/media/Maltego_logo.ed15857a.png";